import { render, staticRenderFns } from "./content-details-view.vue?vue&type=template&id=0166c927&scoped=true"
import script from "./content-details-view.vue?vue&type=script&lang=js"
export * from "./content-details-view.vue?vue&type=script&lang=js"
import style0 from "./content-details-view.vue?vue&type=style&index=0&id=0166c927&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0166c927",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/LRL_LCDDMAC_eMSL_CFC/LRL_LCDDMAC_eMSL_CFC/Frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0166c927')) {
      api.createRecord('0166c927', component.options)
    } else {
      api.reload('0166c927', component.options)
    }
    module.hot.accept("./content-details-view.vue?vue&type=template&id=0166c927&scoped=true", function () {
      api.rerender('0166c927', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/analytics/content-details-view.vue"
export default component.exports